import React from "react";
import { Filter } from "react-bootstrap-icons";

const FiltersButton = ({setShowFilters}) => {
    return (
          <button
            type="button"
            className="btn rounded-circle d-flex align-items-center justify-content-center shadow round-button"
            style={{ cursor: "pointer" }}
            onClick={(e) => {
                e.preventDefault();

                setShowFilters(true);
            }}
        >
            <Filter size={80} />
        </button>
    );
};

export default FiltersButton; 